import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const DealDetails = lazy(() => import("./DealDetails").then((module) => ({ default: module.DealDetails })));

export const DealDetailsAsync = () => {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <DealDetails />
    </Suspense>
  );
};
